import { createSelector } from 'reselect';
import { withoutEuropeanUnion } from 'i18n/countryLabel';
import { StoreState } from 'store/types';
import { CommonState } from './types';
import {
  BusinessSize,
  BusinessType,
  Country,
  CountryFlag,
  Timezone,
} from 'store/common/models';

const commonSelector = (state: StoreState): CommonState => state.common;

export const getCommonLoading = createSelector(
  commonSelector,
  (common: CommonState): CommonState['loading'] => common.loading
);

/** Full country list from the API, including European Union (OSS meta-region). */
export const getAllCommonCountries = createSelector(
  commonSelector,
  (common: CommonState): Country[] => common.countries
);

/**
 * Countries for general UI (entity/billing/contact/transaction dropdowns).
 * Excludes European Union, which is only valid on add/edit return (OSS).
 */
export const getCommonCountries = createSelector(
  getAllCommonCountries,
  (countries: Country[]): Country[] => withoutEuropeanUnion(countries)
);

export const getCommonBusinessTypes = createSelector(
  commonSelector,
  (common: CommonState): BusinessType[] => common.businessTypes
);

export const getCommonBusinessSizes = createSelector(
  commonSelector,
  (common: CommonState): BusinessSize[] => common.businessSizes
);

export const getCommonTimezones = createSelector(
  commonSelector,
  (common: CommonState): Timezone[] => common.timezones
);

export const getCommonCurrencies = createSelector(
  commonSelector,
  (common: CommonState): string[] => common.currencies
);

export const getCurrenciesLoaded = createSelector(
  commonSelector,
  (common: CommonState): boolean => common.currenciesLoaded
);

export const getCountriesExternalData = createSelector(
  commonSelector,
  (common: CommonState): CountryFlag[] => common.countriesExternalData
);